export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8000";

export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY ?? "";

// Site configuration
export const SITE_CONFIG = {
  name: "GoOffline",
  companyName: "M3L Software",
  companyUrl: "https://m3lsoftware.com",
  companyLegalName: "Maciej Marzęta (Owner of M3L Software)",
  domain: "gooffline.me",
  contactEmail: "contact@m3lsoftware.com",
  affiliatePartner: "CD&LP",
  lastUpdated: "2025-01-01"
} as const;